<template>
  <div>
    <h3 class="text-success">Use:</h3>
    <ul>
      <li>Long passwords.</li>
      <li>LastPass or Nexcess's password generator.</li>
      <li>Random words, punctuation, numbers and symbols.</li>
    </ul>
    <h3 class="text-danger">Do not use:</h3>
    <ul>
      <li>A short password.</li>
      <li>A word repeated several times.</li>
      <li>A password you used in other sites.</li>
      <li>Passwords that can easily be identified with you or your social media accounts.</li>
      <li>Common keyboard patterns like: \"1234\" or \"abcdefg\".</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PasswordTips",
  components: {},
  props: {},
  setup() {},
};
</script>
